import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-7" }
const _hoisted_2 = { class: "block" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FormSection from './FormSection.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';

import { ref, onMounted } from 'vue';
import VoucherService from '@/classes/Voucher';
import AuthService from '@/classes/AuthService';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreatePage',
  setup(__props) {

const form = ref({
    name: null,
    code: null,
    package_type: null,
    rider_type: null,
    patient_type: null,
    max_usage_type: null,
    max_usage_count: null,
    requirement_type: null,
    requirement_value: null,
    discount_type: null,
    discount_value: null,
    validity_range_type: null,
    start_at: null,
    end_at: null,
    description: null,
    package_id: [],
    rider_ids: [],
    patient_ids: [],
})

const packages = ref([]);
const services = ref([]);
const allergyTests = ref([]);
const patients = ref([]);
const packageOptions = ref([]);
const riderOptions = ref([]);
const patientOptions = ref([]);
const maxUsageOptions = ref([]);
const requirementOptions = ref([]);
const discountOptions = ref([]);
const validityRangeOptions = ref([]);


const loader = ref(false)
const showSuccess = ref(false);
const showConfirmation = ref(false);
const showError = ref(false)
const errorMsg = ref(null)
const errors      = ref([])

const fetchDropdownsData = () => {
    loader.value = true

    VoucherService.createVoucher()
        .then((result: any) => {
            packages.value = result?.data?.packages;
            services.value = result?.data?.services
            allergyTests.value = result?.data?.allergyTests
            patients.value = result?.data?.patients
            packageOptions.value = result?.data?.packageOptions
            riderOptions.value = result?.data?.riderOptions
            patientOptions.value = result?.data?.patientOptions
            maxUsageOptions.value = result?.data?.maxUsageOptions
            requirementOptions.value = result?.data?.requirementOptions
            discountOptions.value = result?.data?.discountOptions
            validityRangeOptions.value = result?.data?.validityRangeOptions

            loader.value = false;
        })
        .catch((error) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error;

            if(error.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

/**
 * Submit
 */
const submit = async () => {
    loader.value = true;

    try {
        form.value.code = form.value.code ? form.value.code.toUpperCase() : null;

        await VoucherService.storeVoucher(form.value)

        showSuccess.value = true
                
        setTimeout(() => {
            window.location.replace('/vouchers')
        }, 1000);
    }
    catch(error) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = error.response.data.message;

        if(error.response.status == 422) {
            errors.value = error.response.data.errors;
        }
        errorResponse(error)
    }
}

const errorResponse = (err: object) => {
    loader.value = false

    if(err?.response.status == 401) {
        AuthService.redirectToLogin()
    }
}

onMounted(async() => {
    await fetchDropdownsData();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "Create Voucher",
    "show-back": "",
    backUrl: "/vouchers"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, {
          form: form.value,
          packages: packages.value,
          services: services.value,
          allergyTests: allergyTests.value,
          patients: patients.value,
          packageOptions: packageOptions.value,
          riderOptions: riderOptions.value,
          patientOptions: patientOptions.value,
          maxUsageOptions: maxUsageOptions.value,
          requirementOptions: requirementOptions.value,
          discountOptions: discountOptions.value,
          validityRangeOptions: validityRangeOptions.value,
          errors: errors.value
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(ButtonComponent, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showConfirmation.value = true))
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" Create Voucher ", -1)
                ]))]),
                _: 1
              }),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-sm text-gray-600" }, [
                _createElementVNode("b", null, "Note:"),
                _createTextVNode(" once the voucher is created it can no longer be updated ")
              ], -1))
            ])
          ]),
          _: 1
        }, 8, ["form", "packages", "services", "allergyTests", "patients", "packageOptions", "riderOptions", "patientOptions", "maxUsageOptions", "requirementOptions", "discountOptions", "validityRangeOptions", "errors"])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Voucher",
        content: "Voucher Created Successfully!"
      }, null, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[5] || (_cache[5] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => {showConfirmation.value = false; submit()}),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Confirm Voucher Creation?",
        content: "Once the voucher is created it can no longer be updated."
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})